import { Box, Container, Typography } from "@mui/material";
import PageTitle from "./components/PageTitle";
export default function Page404() {
    return (
        <Container maxWidth='md' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
            <PageTitle title="Сторінку не знайдено" />
            <Box>
                <Typography variant='h1' textAlign='center'>404</Typography>
                <Typography variant='h2' textAlign='center'>Сторінку не знайдено!</Typography>
            </Box>
        </Container>
    )
}
